import { createApp } from 'vue'
import App from './MyApp.vue'

createApp(App).mount('#app')